import { useEffect, useState } from "react";

import { apiRequest } from "./api";

function formatCountdown(totalSeconds) {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export default function VerifyOtpView({ email, onBackToSignup, onVerificationSuccess }) {
  const [otp, setOtp] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");
  const [secondsLeft, setSecondsLeft] = useState(300);

  useEffect(() => {
    setSecondsLeft(300);
  }, [email]);

  useEffect(() => {
    if (secondsLeft <= 0) {
      return undefined;
    }

    const timer = window.setInterval(() => {
      setSecondsLeft((current) => {
        if (current <= 1) {
          window.clearInterval(timer);
          return 0;
        }
        return current - 1;
      });
    }, 1000);

    return () => window.clearInterval(timer);
  }, [secondsLeft]);

  async function handleSubmit(event) {
    event.preventDefault();
    setSubmitting(true);
    setStatus("");
    setError("");

    try {
      const payload = await apiRequest("/auth/signup/verify-otp/", {
        method: "POST",
        body: JSON.stringify({
          email,
          otp,
        }),
      });

      setStatus(payload.message || "Email verified successfully.");
      onVerificationSuccess(payload.redirectUrl);
    } catch (requestError) {
      setError(requestError.message || "Unable to verify OTP.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section className="auth-panel">
      <div className="auth-panel__header">
        <p className="eyebrow">Email Verification</p>
        <h2>Verify your company registration</h2>
        <p className="config-note">
          We have sent an OTP to <strong>{email}</strong>. Enter it below to finish company setup.
        </p>
      </div>

      {status ? <p className="config-banner config-banner--success">{status}</p> : null}
      {error ? <p className="form-error">{error}</p> : null}

      <form className="auth-form" onSubmit={handleSubmit}>
        <label>
          One-Time Password
          <input
            type="text"
            value={otp}
            onChange={(event) => setOtp(event.target.value)}
            placeholder="Enter OTP"
            maxLength={6}
            required
          />
        </label>

        <p className={`otp-timer${secondsLeft === 0 ? " is-expired" : ""}`}>
          OTP expires in: {secondsLeft > 0 ? formatCountdown(secondsLeft) : "Expired"}
        </p>

        <div className="auth-form__actions">
          <button className="primary-button" type="submit" disabled={submitting || secondsLeft === 0}>
            {submitting ? "Verifying..." : "Verify OTP"}
          </button>
          <button className="ghost-button" type="button" onClick={onBackToSignup}>
            Back to Signup
          </button>
        </div>
      </form>
    </section>
  );
}
